import React from 'react';
import Box from '@mui/material/Box';

export default function SalesTableCell(props) {
  const { th, sx, unit, children, ...rest } = props;

  return (
    <Box
      sx={{
        py: 1,
        fontSize: '14px',
        ...th,
        ...sx
      }}
    >
      <>
        {children} {unit || ''}
      </>
    </Box>
  );
}
